import { Clock, Globe, UserPlus } from "lucide-react";
import { useAppNavigation } from "@/shared/hooks/useAppNavigation";
import { ActionTile } from "@/shared/components/ui/ActionTile";
import { Section } from "@/shared/components/ui/Section";

export function DashboardActions() {
  const { goToWebsite, goToClientAdd, goToAvailabilities } = useAppNavigation();
  const tileClass = "min-h-[120px] flex-col items-start justify-start gap-3 p-4 [&_svg]:size-6 [&>span:last-child]:text-left";

  return (
    <Section title="Quick actions">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
        <ActionTile title="Booking website" icon={<Globe />} className={tileClass} onClick={goToWebsite} />
        <ActionTile title="Add customer" icon={<UserPlus />} className={tileClass} onClick={goToClientAdd} userAction="client.add_start" />
        <ActionTile title="Working hours" icon={<Clock />} className={tileClass} onClick={goToAvailabilities} />
      </div>
    </Section>
  );
}
